"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _constants = require("../utils/constants");

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _avatar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/avatar.css") : void 0);

var _icon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/icon.css") : void 0);

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread({}, _icon.default), _avatar.default));
/** An **Avatar** is a visual presentation option around using an icon or user initials. */

var Avatar = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _context, _context2, _classnames;

  var glyph = _ref.glyph,
      size = _ref.size,
      circle = _ref.circle,
      cssNamespace = _ref.cssNamespace,
      transparent = _ref.transparent,
      border = _ref.border,
      color = _ref.color,
      label = _ref.label,
      backgroundImageUrl = _ref.backgroundImageUrl,
      children = _ref.children,
      className = _ref.className,
      role = _ref.role,
      placeholder = _ref.placeholder,
      tile = _ref.tile,
      zoom = _ref.zoom,
      zoomLabel = _ref.zoomLabel,
      props = (0, _objectWithoutProperties2.default)(_ref, ["glyph", "size", "circle", "cssNamespace", "transparent", "border", "color", "label", "backgroundImageUrl", "children", "className", "role", "placeholder", "tile", "zoom", "zoomLabel"]);
  var styles = {
    backgroundImage: "url(".concat(backgroundImageUrl, ")")
  };
  var avatarClasses = classnames("".concat(cssNamespace, "-avatar"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, (0, _concat.default)(_context = "".concat(cssNamespace, "-avatar--")).call(_context, size), !!size), (0, _defineProperty2.default)(_classnames, (0, _concat.default)(_context2 = "".concat(cssNamespace, "-avatar--accent-color-")).call(_context2, color), !!color), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-avatar--thumbnail"), backgroundImageUrl), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-avatar--placeholder"), placeholder), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-avatar--tile"), tile), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-avatar--circle"), circle), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-avatar--transparent"), transparent), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-avatar--border"), border), _classnames), className);
  var ariaRole;

  if (role) {
    ariaRole = role;
  } else {
    ariaRole = !children ? 'presentation' : '';
  }

  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, props, {
    "aria-label": label,
    className: avatarClasses,
    ref: ref,
    role: ariaRole,
    style: backgroundImageUrl && styles
  }), glyph && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    ariaHidden: true,
    className: classnames("".concat(cssNamespace, "-avatar__icon")),
    glyph: glyph
  }), zoom && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    ariaLabel: zoomLabel,
    className: classnames("".concat(cssNamespace, "-avatar__zoom-icon")),
    glyph: 'edit'
  }), children);
});

Avatar.displayName = 'Avatar';
process.env.NODE_ENV !== "production" ? Avatar.propTypes = {
  /** Image URL */
  backgroundImageUrl: _propTypes.default.string,

  /** Set to **true** to include a border */
  border: _propTypes.default.bool,

  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** Apply circl style to Avatar */
  circle: _propTypes.default.bool,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Applies a background color */
  color: _CustomPropTypes.default.range(1, 9),

  /** The icon to include. See the icon page for the list of icons */
  glyph: _propTypes.default.string,

  /** Localized text for label */
  label: _propTypes.default.string,

  /** Set to **true** to apply placeholder background color */
  placeholder: _propTypes.default.bool,

  /** Applies an aria-role. Set to button if Avatar opens a Popover or Dialog */
  role: _propTypes.default.string,

  /** Size of the component:
  'xs',
  's',
  'm',
  'l',
  'xl' */
  size: _propTypes.default.oneOf(_constants.AVATAR_SIZES),

  /** Set to **true** to apply tile background color */
  tile: _propTypes.default.bool,

  /** Set to **true** to use transparent background */
  transparent: _propTypes.default.bool,

  /** Set to **true** to include a zoom icon */
  zoom: _propTypes.default.bool,

  /** Localized text for zoom icon label */
  zoomLabel: _propTypes.default.string
} : void 0;

var _default = (0, _withStyles.default)(Avatar);

exports.default = _default;